function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import PropTypes from 'prop-types';
import { ButtonBack, ButtonNext } from 'pure-react-carousel';
import { ChevronRight, ChevronLeft } from 'pcln-icons';
import { Wrapper } from './ArrowButton.styles';
const ArrowButton = _ref => {
  let {
    type,
    position,
    setPosition,
    showArrowsOnHover,
    ...props
  } = _ref;
  return setPosition === position ? /*#__PURE__*/React.createElement(Wrapper, _extends({
    type: type,
    position: position
  }, props, {
    "data-testid": `${type}-${position}`,
    showArrowsOnHover: showArrowsOnHover
  }), type === 'prev' ? /*#__PURE__*/React.createElement(ButtonBack, null, /*#__PURE__*/React.createElement(ChevronLeft, {
    size: type === 'side' ? 40 : 32,
    ml: "-3px"
  })) : /*#__PURE__*/React.createElement(ButtonNext, null, /*#__PURE__*/React.createElement(ChevronRight, {
    size: type === 'side' ? 40 : 32,
    mr: "-3px"
  }))) : null;
};
ArrowButton.defaultProps = {
  buttonBackground: 'background.lightest',
  buttonColor: 'primary.base',
  buttonHoverBackground: 'background.base',
  buttonHoverColor: 'primary.dark',
  buttonSize: '60px'
};
ArrowButton.propTypes = {
  type: PropTypes.oneOf(['prev', 'next']),
  position: PropTypes.oneOf(['side', 'top', 'bottom', 'hide']),
  setPosition: PropTypes.oneOf(['side', 'top', 'bottom', 'hide']),
  /** color.shade pattern to be passed to getPaletteColor */
  buttonBackground: PropTypes.string,
  /** color.shade pattern to be passed to getPaletteColor */
  buttonColor: PropTypes.string,
  /** color.shade pattern to be passed to getPaletteColor */
  buttonHoverBackground: PropTypes.string,
  /** color.shade pattern to be passed to getPaletteColor */
  buttonHoverColor: PropTypes.string,
  /** same value used for button width and button height */
  buttonSize: PropTypes.string,
  /** When arrow position is side, hide arrows and shows when hovers on carousel */
  showArrowsOnHover: PropTypes.bool,
  /** adjust side arrow position for overflow */
  overflowAdjust: PropTypes.number
};
export { ArrowButton };